module.exports = __webpack_public_path__ + "img/orange_078.217eb3a1.png";